import { SelfServiceAPI } from 'types';

const shouldUpdatePaymentMethod = (booking: SelfServiceAPI.UpcomingBooking): boolean => {
  const { hasPendingScheduledPayment, isCreditCardExpired } = booking.flags;
  return hasPendingScheduledPayment && isCreditCardExpired;
};

export default shouldUpdatePaymentMethod;
